import { app } from "@/modules/app";
import { useStackRouteComponent } from "@/packages/stack-router/hooks/useStackRoute";

//const {entityTypesByRole} = useEntityRegistry()
//const entityType = entityTypesByRole.catalog

app.addRoutes([
    {
        parent: 'public',
        path: '/catalog/:sectionCode',
        component: () => import("@/pages/shop/catalog/section.page.vue"),
        meta: {},
        props: true,
    },
    {
        parent: 'public',
        path: '/product/:id',
        component: useStackRouteComponent(
            () => import("@/pages/shop/catalog/product.dialog.vue"),
            {
                routeComponent: () => import("@/pages/shop/catalog/product.page.vue")
            }
        ),
        meta: {},
        props: true,
    },
    {
        parent: 'public',
        path: '/section-filters/:id',
        component: useStackRouteComponent(
            () =>  import("@/components/Shop/ProductSection/SectionFilters.dialog.vue"),
        ),
        meta: {}
    },
    {
        parent: 'public',
        path: '/catalog/search',
        component: useStackRouteComponent(() => import("@/pages/shop/catalog/search.dialog.vue")),
        meta: {}
    },
    {
        parent: "public",
        path: "/basket/available-modificators",
        component: useStackRouteComponent(
            () => import("@/pages/shop/vorder/basket-available-modificators.dialog.vue")
        ),
        meta: {
            title: "Дополните ваш заказ",
        },
    },
    {
        parent: "public",
        path: "/basket/rules-gifts",
        component: useStackRouteComponent(
            () =>  import("@/pages/shop/vorder/basket-rules-gifts.dialog.vue")
        ),
        meta: {
            title: "Выберите подарок",
        },
    },
    {
        parent: "public",
        path: "/order",
        component: useStackRouteComponent(
            () => import("@/pages/shop/vorder/vorder.dialog.vue")
        ),
        meta: {},
    },
    {
        parent: "public",
        path: "/shop/vorder-confirm",
        component: useStackRouteComponent(
            () => import("@/pages/shop/vorder/vorder-confirm.dialog.vue")
        ),
        meta: {
            title: "Подтверждение заказа",
        },
    },
    {
        parent: "public",
        path: "/personal/order/:id",
        component: useStackRouteComponent(
            () => import("@/pages/shop/personal/order/dialog/order-view.dialog.vue")
        ),
        meta: {},
        props: true,
    },
    {
        parent: "guest",
        path: "/guest/orders",
        component: () => import("@/pages/shop/personal/order/guest-orders-active.page.vue"),
        meta: {
            title: "Активные заказы",
        },
        props: true,
    },
    {
        parent: "public",
        path: "/order/track/:orderId",
        component: useStackRouteComponent(
            () =>  import("@/pages/shop/personal/order/dialog/order-track.dialog.vue")
        ),
        meta: {
            title: "Отслеживание заказа",
        },
        props: true,
    },
]);

